function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function groupWalletsByCategory(wallets) {
	return wallets.reduce((acc, wallet) => {
		if (wallet.type !== "asset" && wallet.type !== "liability") {
			const type = capitalizeFirstLetter(wallet.type);
			acc[type] = acc[type] || [];
			acc[type].push(wallet);
		} else {
			const category = wallet.category || "Other";
			acc[category] = acc[category] || [];
			acc[category].push(wallet);
		}
		return acc;
	}, {});
}
